import { render, staticRenderFns } from "./RunHoursDetailsModal.vue?vue&type=template&id=4c45c5b8"
import script from "./RunHoursDetailsModal.vue?vue&type=script&lang=js"
export * from "./RunHoursDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports